import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { UnknownErrorMessage } from "@/common/components/UnknownErrorMessage";
import { useMemo } from "react";
import { maintenanceForwardingStatus } from "../../../constants/maintenanceForwardingStatus.constant";
import { useMaintenanceForwarding } from "../../../features/forwardings/hooks/useMaintenanceForwarding";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";

interface MaintenanceWorkflowForwardingShowProps {
  forwardingId: string;
}

const MaintenanceWorkflowForwardingShow = ({ forwardingId }: MaintenanceWorkflowForwardingShowProps) => {
  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
  } = useMaintenanceForwarding(forwardingId);

  const ForwardingStateComponent = useMemo(() => {
    if (!forwarding?.status) {
      return false;
    }

    return maintenanceForwardingStatus[forwarding?.status]?.component || false;
  }, [forwarding?.status]);

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingError?.status}
      refetchFunction={refetchForwarding}
    >
      {forwarding && ForwardingStateComponent && (
        <ForwardingStateComponent forwarding={forwarding} />
      )}

      {(!forwarding || !ForwardingStateComponent) && (
        <UnknownErrorMessage className="flex-1" />
      )}
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingShow;
